export enum UserRolesEnum {
    SUPER_ADMIN = 'SUPER_ADMIN',
    CLOSER_INTERNO = 'CLOSER_INTERNO',
    CLOSER_INTERNO_ADVOGADO = 'CLOSER_INTERNO_ADVOGADO',
    SDR_INTERNO = 'SDR_INTERNO',
    SDR_INTERNO_ADVOGADO = 'SDR_INTERNO_ADVOGADO',

    CLOSER_EXTERNO = 'CLOSER_EXTERNO',
    SDR_EXTERNO = 'SDR_EXTERNO',
}